import { AfterViewInit, Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { InputComponent } from '@app/core/components/input/input.component';
import { ListButton } from '@app/core/components/list/list.component';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { ProductChoiceItem, ProductService } from '@app/services/product.service';
import { ProductSelectionService } from '@app/services/product-selection.service';

@Component({
    selector: 'tt-select-prod-choice',
    templateUrl: './select-prod-choice.component.html',
    styleUrls: ['./select-prod-choice.component.css'],
    standalone: false
})
export class SelectProdChoiceComponent implements OnInit, AfterViewInit {
    public items: ProductChoiceItem[] = [];

    public searchText = '';

    public loading = false;

    public error = '';

    private pendingLoads = 0;

    private choiceKeyno = '';

    private argType = '';

    private argValue = '';

    @ViewChild(InputComponent)
    private searchInput?: InputComponent<string>;

    constructor(
        private product: ProductService,
        private selection: ProductSelectionService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async ngOnInit(): Promise<void> {
        this.choiceKeyno = String(this.navigator?.params['choice_keyno'] ?? '');
        this.argType = String(this.navigator?.params['argtype'] ?? '');
        this.argValue = String(this.navigator?.params['argvalue'] ?? '');

        await this.loadChoices();
    }

    public ngAfterViewInit(): void {
        this.searchInput?.inputRef?.nativeElement.focus();
    }

    public async loadChoices(): Promise<void> {
        if (typeof this.searchText !== 'string') return;

        this.loading = true;
        ++this.pendingLoads;
        this.error = '';

        try {
            this.items = await this.product.listProductChoices({
                prodchoice_search: this.searchText,
                choice_keyno: this.choiceKeyno,
                argtype: this.argType,
                argvalue: this.argValue
            });
        } catch (error) {
            this.error = error instanceof Error ? error.message : String(error);
        } finally {
            this.loading = --this.pendingLoads > 0;
        }
    }

    public search(): void {
        if (!this.loading) void this.loadChoices();
    }

    public changeSearch(value: string): void {
        if (value === undefined || value === this.searchText) return;

        this.searchText = value;

        if (value === '') void this.loadChoices();
    }

    public clearSearch(): void {
        this.searchText = '';
        void this.loadChoices();
    }

    public select(item: ProductChoiceItem): void {
        if (item.item_id === '') return;

        this.selection.selectChoice({
            prod_id: item.item_id,
            prod_name: item.item_name,
            choice_keyno: this.choiceKeyno
        });

        this.navigator?.back();
    }
}
